<template>
  <nav
    v-if="crumbs.length"
    class="breadcrumbs links-unstyled font-display max-w-full overflow-auto text-10 lg:text-12 uppercase"
    :class="{scrolling: forceScrollEnd}"
    aria-label="Murupolku"
  >
    <ul :class="$attrs.class" class="list-reset grid grid-flow-col gap-2 py-4 overflow-x-auto justify-start">
      <li v-if="!hideHome" class="whitespace-nowrap flex items-center">
        <router-link to="/">
          <home-icon size="1.5x" />
        </router-link>
        <chevron-right-icon size="1x" class="ml-2" aria-hidden="true" />
      </li>
      <li v-for="crumb in crumbs" :key="crumb.id" class="whitespace-nowrap flex items-center">
        <span v-if="crumb.current" class="opacity-50">
          {{ crumb.name }}
        </span>
        <router-link v-else :to="crumb.slug" :aria-current="crumb.current ? 'page' : 'false'">
          {{ crumb.name }}
        </router-link>
        <chevron-right-icon
          v-if="!crumb.current"
          size="1x"
          class="ml-2"
          aria-hidden="true"
        />
      </li>
    </ul>
  </nav>
</template>

<script>
import { HomeIcon, ChevronRightIcon } from '@bit/vekenkaluste.veke-ui.icons'

export default {
  name: 'Breadcrumbs',
  components: { HomeIcon, ChevronRightIcon },
  inheritAttrs: false,
  props: {
    hideHome: {
      type: Boolean,
      required: false,
      default: false
    },
    breadcrumbs: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data () {
    return {
      forceScrollEnd: true
    }
  },
  computed: {
    crumbs () {
      return this.breadcrumbs.map((crumb, i) => ({
        ...crumb,
        current: i === this.breadcrumbs.length - 1
      }))
    }
  },
  mounted () {
    setTimeout(() => { this.forceScrollEnd = false }, 50)
  }
}
</script>

<style lang="scss">
  .breadcrumbs {
    > ul {
      scroll-behavior: smooth;
      scroll-snap-type: x mandatory;
      overscroll-behavior-x: contain;
      > li:last-of-type {
        scroll-snap-align: none;
        @apply pr-8;
      }
    }
    &.scrolling > ul > li:last-of-type {
      scroll-snap-align: end;
    }
  }
</style>
